// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2e1gb","addWidgetButton":"Header_addWidgetButton__3YjpV","dashboardTabs":"Header_dashboardTabs__376Q-","active":"Header_active__2Tm_6"};